<template>
  <div class="admin-projects-certificate">
    <el-input clearable v-model="filterTerm" placeholder="请输入App名称进行筛选"
      style="width: 300px;text-transform:uppercase;margin-bottom: 20px">
      <template #suffix>
        <i class="iconfont icon-sousuo"></i>
      </template>
    </el-input>
    <el-table :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="appname" sortable label="App名称">
      </el-table-column>
      <el-table-column prop="bundle_id" sortable width="250" label="Bid">
      </el-table-column>
      <el-table-column prop="projectname" sortable label="项目名称">
      </el-table-column>
      <el-table-column prop="personincharge" sortable label="负责人">
      </el-table-column>
      <el-table-column sortable prop="rel_expire_time" width="350" label="rel证书">
        <template #default="scope">
          <div class="fl">
            <el-button class="el-button" size="small" @click="handleDownload(scope.row, 'rel')">
              <i class="iconfont icon-sousuo"></i> 下载
            </el-button>
          </div>
          <div class="fl paddingLeft">
            <p>创建时间：
              <span v-if="scope.row.rel_update_time === '0001-01-01T00:00:00Z'" style="color:red">失效</span>
              <span v-else>{{ formatDateTime(scope.row.rel_update_time) }}</span>
            </p>
            <p>剩余时间：
              <span v-if="scope.row.rel_expire_time === '0001-01-01T00:00:00Z'" style="color:red">失效</span>
              <span v-else>
                <CountDown :endTime="formatDateTime(scope.row.rel_expire_time)" />
              </span>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="dev_expire_time" width="350" label="dev证书">
        <template #default="scope">
          <div class="fl">
            <el-button class="el-button" size="small" @click="handleDownload(scope.row, 'dev')">
              <i class="iconfont icon-sousuo"></i> 下载
            </el-button>
          </div>
          <div class="fl paddingLeft">
            <p>创建时间：
              <span v-if="scope.row.dev_update_time === '0001-01-01T00:00:00Z'" style="color:red">失效</span>
              <span v-else>{{ formatDateTime(scope.row.dev_update_time) }}</span>
            </p>
            <p>剩余时间：
              <span v-if="scope.row.dev_expire_time === '0001-01-01T00:00:00Z'" style="color:red">失效</span>
              <span v-else>
                <CountDown :endTime="formatDateTime(scope.row.dev_expire_time)" />
              </span>
            </p>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { formatDateTime, searchString } from "@/Utils/UtilTools";
import { getCurrentInstance, onMounted, reactive, ref, watch } from "vue";
import CountDown from "@/Components/CountDown.vue";
import { apiGetCertificateAll } from "@/Api/AppApi";

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const filterTerm = ref('');

function handleDownload(row, text) {
  const data = {
    project: row.project_id,
    appid: row.app_id,
    cert_type: text,
    bundle_id: row.bundle_id
  };
  window.location.href = "/api/certificate/download?project=" + data.project + "&appid=" + data.appid + "&cert_type=" + data.cert_type + "&bundle_id=" + data.bundle_id;
}

const list = ref([]);
const loading = ref(false);
onMounted(async () => {
  loading.value = true;
  const res = await apiGetCertificateAll();
  loading.value = false;
  if (res.code === 0) {
    list.value = res.data;
  } else {
    $message.error(res.message);
  }
});

const tableData = ref([]);
watch([filterTerm, list], () => {
  tableData.value = list.value.filter(p => !filterTerm.value || searchString(filterTerm.value, p.appname));
  tableData.value = tableData.value.sort((a, b) => Date.parse(b.rel_expire_time) > Date.parse(a.rel_expire_time) ? -1 : Date.parse(b.rel_expire_time) < Date.parse(a.rel_expire_time) ? 1 : 0);
});
</script>

<style lang="scss" scoped>
.admin-projects-certificate {
  padding: 20px;
  width: 100%;
  height: 100%;
  overflow: auto;

  & :deep() .el-dialog__body {
    padding: 0px 0px 0px 10px;
  }
}

.fl {
  float: left;
}

.paddingLeft {
  padding-left: 20px;
}

.paddingLeft p {
  margin: 0;
}

.el-button {
  margin-top: 6px;
}
</style>